"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.THUMB_FILE_NAME_PREFIX = exports.LOGO_FILE_NAME_PREFIX = void 0;
exports.LOGO_FILE_NAME_PREFIX = 'logo';
exports.THUMB_FILE_NAME_PREFIX = 'cc_thumb_';
